<template>
	<div class="row">
 

		<div class="col-md-12">
			<div>
				When all requirements are met user will receive <input style="width: fit-content;display: inline;"
																	 maxlenght="6" size="6" id="points" name="points"
																	 class="form-control" type="text"
																	 v-model.number="points"/> points.
				<span class="invalid-feedback" style="display: block;" v-if="errors.points">@{{ errors.points }}</span>
			</div>
		</div>
		<div class="col col-md-12" >
			<label class="control-label col-lg-3" for="categories">Categories:</label>
			<div  >
				<table class="table table-sm table-striped discount-list">
					<thead>
					<tr>
						<th>Categories</th>
						<th>Redemptions Required</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(category, index) in rule.settings.categories" :key="index">
						<td>
							
							<select class="delay input-small form-control" v-model="category.id">
								<option :value="null">Select Category</option>
								<option v-for="category in allCategories" :value="category.id" :key="category.id">{{ category.name }}</option>
							</select>
						</td>
						<td>
							<input
								class="form-control no-underline"
								hide-details
								v-model.number="category.count"
								type="number"
								min="1"
								@blur="fix(category)"
							></input>
						</td>
						<td>
							<button class="btn btn-danger" @click="confirmDeleteCategory(index)">Delete</button>
						</td>
					</tr>
					</tbody>
				</table>
				<button class="btn btn-primary" @click.prevent="addCategory">Add Category</button>
			</div>
		</div>

	</div>
</template>

<script>

export default {
	props: {
		categories: Array,
		deal: Object,
		deals: Array,
		products: Array,
		rule: Object,
		venues: Array,
	},
	data: () => ({
		filterCategories: [],
		errors: {},
	}),
	methods: {
		addCategory() {
			if(!this.rule.settings) {
				this.$set(this.rule, 'settings', {
					points: '',
					categories: []
				});
			}
			if(!this.rule.settings.categories) {
				this.$set(this.rule.settings, 'categories', []);
			}
			this.rule.settings.categories.push({
				id: null,
				count: 1,
			});
		},
		confirmDeleteCategory(index) {
			if (confirm('Are you sure you want to delete this category?')) {
				this.rule.settings.categories.splice(index, 1);
			}
		},
		fix(category) {
			if (isNaN(category.count) || category.count < 1) {
				category.count = 1;
			}
		}
	},
	computed: {
		allCategories() {
			return this.categories.filter(category => this.deal.pass_settings?.venue_category_sort_ids?.includes(category.id));
		},

		points: {
			get() {
				return this.rule.settings.points;
			},
			set(newVal) {
				this.$set(this.rule.settings, 'points', newVal);
			},
		},
	}
}
</script>
 